import { render, staticRenderFns } from "./AreaDoAssociadoValidaCodigoDeclaracao.vue?vue&type=template&id=13e27ef6&"
import script from "./AreaDoAssociadoValidaCodigoDeclaracao.vue?vue&type=script&lang=js&"
export * from "./AreaDoAssociadoValidaCodigoDeclaracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports